import axios from "axios";
import AllRoutes from "../../nametitle/AllRoutes";
import { baseUrl } from "../../nametitle/dataUrl";


// Créer un compte 
export const CreateUser = (username, firstname, lastname, email,code, telephone, password) => {
  var data = JSON.stringify({
    "username": username,
    "firstname": firstname,
    "lastname": lastname,
    "email": email,
    "code":code,
    "telephone": telephone,
    "password": password
  });
  var config = {
    method: 'post',
    url: `${baseUrl.baseUrl}/api/v1/users/`,
    headers: {
      'Authorization': `Bearer ${baseUrl.token}`,
      'Content-Type': 'application/json',
      'Cookie': 'JSESSIONID=4929A2A226D1D000ECA1AF8906558AF0'
    },
    data: data
  };
  axios(config)
    .then(function (response) {
      //console.log(JSON.stringify(response.data));
      window.location.reload();
    })
    .catch(function (error) {
      //console.log(error);
    });
}

// Mise ajour du compte 
export const UpdateUser = (id, username, firstname, lastname, email, code, telephone, password) => {
  var data = JSON.stringify({
    "username": username,
    "firstname": firstname,
    "lastname": lastname,
    "email": email,
    "code": code,
    "telephone": telephone,
    // "password":password
  });

  var config = {
    method: 'put',
    url: `${baseUrl.baseUrl}/api/v1/users/edit/${id}`,
    headers: {
      'Authorization': `Bearer ${baseUrl.token}`,
      'Content-Type': 'application/json',
      'Cookie': 'JSESSIONID=4929A2A226D1D000ECA1AF8906558AF0'
    },
    data: data
  };
  axios(config)
    .then(function (response) {
      // //console.log(JSON.stringify(response.data));
      window.location.reload();
    })
    .catch(function (error) {
      //console.log(error);
      alert("Update user failed !")
    });

}



export const UpdateUserPassword = (id, password) => {
  var data = JSON.stringify({
    "password":password
  });

  var config = {
    method: 'put',
    url: `${baseUrl.baseUrl}/api/v1/users/password/${id}`,
    headers: {
      'Authorization': `Bearer ${baseUrl.token}`,
      'Content-Type': 'application/json',
      'Cookie': 'JSESSIONID=4929A2A226D1D000ECA1AF8906558AF0'
    },
    data: data
  };
  axios(config)
    .then(function (response) {
      // //console.log(JSON.stringify(response.data));
      window.location.reload();
    })
    .catch(function (error) {
      //console.log(error);
      alert("Update password user failed !")
    });

}





// **************************************************************   Mise ajour du mot de passe
export const UpdatePasswordUser = (id, password, redirect) => {
  var data = JSON.stringify({
    "password": password,
  });
  var config = {
    method: 'put',
    url: `${baseUrl.baseUrl}/api/v1/users/${id}`,
    headers: {
      'Authorization': `Bearer ${baseUrl.token}`,
      'Content-Type': 'application/json',
      'Cookie': 'JSESSIONID=4929A2A226D1D000ECA1AF8906558AF0'
    },
    data: data
  };
  axios(config)
    .then(function (response) {
      //console.log(JSON.stringify(response.data));
      // redirect(`/${AllRoutes.admin}/${AllRoutes.userlist}`);
      window.location.reload();
    })
    .catch(function (error) {
      //console.log(error);
      alert("Update user password failed")
    });
}

// ************************************************ Bloquer acces au compte 
export const StopUser = (id) => {
  var data = JSON.stringify({
    "access": false,
  });
  var config = {
    method: 'put',
    url: `${baseUrl.baseUrl}/api/v1/users/hide/${id}`,
    headers: {
      'Authorization': `Bearer ${baseUrl.token}`,
      'Content-Type': 'application/json',
      'Cookie': 'JSESSIONID=4929A2A226D1D000ECA1AF8906558AF0'
    },
    data:data
  };
  axios(config)
    .then(function (response) {
      //console.log(JSON.stringify(response.data));
      window.location.reload();
    })
    .catch(function (error) {
      //console.log(error);
      alert("User not stopped")
    });
}
// ********************************************* Débloquer un compte 
export const AccessUser = (id) => {
  var data = JSON.stringify({
    "access": true,
  });
  var config = {
    method: 'put',
    url: `${baseUrl.baseUrl}/api/v1/users/show/${id}`,
    headers: {
      'Authorization': `Bearer ${baseUrl.token}`,
      'Content-Type': 'application/json',
      'Cookie': 'JSESSIONID=4929A2A226D1D000ECA1AF8906558AF0'
    },
    data:data
  };
  axios(config)
    .then(function (response) {
      //console.log(JSON.stringify(response.data));
      window.location.reload();
    })
    .catch(function (error) {
      //console.log(error);
      alert("Error User not access")
    });
}
// Recupérer tout compte des utlisateurs
export const LoadAllUser = (SetState) => {
  axios.get(`${baseUrl.baseUrl}/api/v1/users/get/all`, {
    headers: {
      'Authorization': `Bearer ${baseUrl.token}`,
      'Content-Type': 'application/json',
      'Cookie': 'JSESSIONID=4929A2A226D1D000ECA1AF8906558AF0'
    }
  })
    .then(function (response) {
      //console.log(JSON.stringify(response.data));
      SetState(response.data.data)
    })
    .catch(function (error) {
      //console.log(error);
    });
}

// Recuperer tout compte des utlisateurs 
export const LoadAllStopUser = (SetState) => {
  axios.get(`${baseUrl.baseUrl}/api/v1/users/`, {
    headers: {
      'Authorization': `Bearer ${baseUrl.token}`,
      'Content-Type': 'application/json',
      'Cookie': 'JSESSIONID=4929A2A226D1D000ECA1AF8906558AF0'
    }
  })
    .then(function (response) {
      //console.log(JSON.stringify(response.data));
      SetState(response.data.data)
    })
    .catch(function (error) {
      //console.log(error);
    });
}